import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import {
    OrganizationId,
    UpdateUserRolesOptions,
    UserId,
    UserWithPolicy
} from "@xapp/stentor-api-client/dist/StentorClient";

import { Credentials } from "auth";

import { State } from "redux/state";

export type UpdateUserRoles = "UPDATE_USER_ROLES";
export const UPDATE_USER_ROLES: UpdateUserRoles = "UPDATE_USER_ROLES";
export type UpdateUserRolesEnd = "UPDATE_USER_ROLES_END";
export const UPDATE_USER_ROLES_END: UpdateUserRolesEnd = "UPDATE_USER_ROLES_END";

export interface UpdateUserRolesAction extends Action {
    payload: {
        credentials: Credentials;
        options: UpdateUserRolesOptions;
        organizationId: OrganizationId;
        userId: UserId;
    };
    type: UpdateUserRoles;
}

export interface UpdateUserRolesEndAction extends Action {
    payload: {
        error?: Error;
        organizationId: string;
        user: UserWithPolicy;
    };
    type: UpdateUserRolesEnd;
}

export function updateUserRoles(
    userId: UserId,
    org: OrganizationId,
    opts: UpdateUserRolesOptions
): ThunkAction<void, State, undefined, UpdateUserRolesAction> {
    return (dispatch: Dispatch<UpdateUserRolesAction>, getState) => {
        const state = getState();

        dispatch(updateUserRolesWithCredentials(state.auth.credentials, userId, org, opts));
    };
}

function updateUserRolesWithCredentials(
    credentials: Credentials,
    userId: UserId,
    org: OrganizationId,
    opts: UpdateUserRolesOptions
): UpdateUserRolesAction {
    return {
        payload: {
            credentials,
            options: opts,
            organizationId: org,
            userId
        },
        type: UPDATE_USER_ROLES
    };
}

export function updateUserRolesEnd(
    error: Error,
    organizationId: string,
    user?: UserWithPolicy
): UpdateUserRolesEndAction {
    return {
        payload: {
            error,
            organizationId,
            user
        },
        type: UPDATE_USER_ROLES_END
    };
}
